var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSim = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SIM_updated",
    "data-name": "SIM updated",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M725,925H300a50,50,0,0,1-50-50V125a50,50,0,0,1,50-50H600L775,250h0V875A50,50,0,0,1,725,925ZM300,475V575H425V450H325A25,25,0,0,0,300,475Zm275-25H450V600H300V725H575V450Zm150,25a25,25,0,0,0-25-25H600V575H725V475Zm0,125H600V725H725V600Zm0,150H600V875H575V750H450V875H425V750H300V850a25,25,0,0,0,25,25H700a25,25,0,0,0,25-25V750Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSim, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Sim.c490bf44.svg";
export { ForwardRef as ReactComponent };